/**
 * Yuna full-width ATC on product cards.
 *
 * Single responsibility: when a `[data-groovi-quick-atc]` button is clicked,
 * delegate to the hidden native `<quick-add-component>` inside the same
 * `<product-card>`. Horizon's server-side bifurcation (`data-quick-add-button`)
 * picks which native button is active:
 *   - "add"    → form submit → CartLinesUpdateEvent → cart drawer (via product-form.js)
 *   - "choose" → quick-add-component.handleClick → native modal opens
 *
 * Zero cart-logic re-implementation — the native path fires untouched.
 * The visible click animation lives on the groovi button via the standard
 * `.add-to-cart-button[data-added='true']` cascade (base.css:4134+).
 */

(function () {
  if (window.__grooviCardAtcInit) return;
  window.__grooviCardAtcInit = true;

  document.addEventListener('click', function (event) {
    var btn = event.target instanceof Element ? event.target.closest('[data-groovi-quick-atc]') : null;
    if (!btn || btn.disabled) return;

    event.preventDefault();

    // Re-entrancy guard: 800ms matches the native animation reset window
    // (assets/product-form.js:159, also the cross-sell pattern — DECISIONS.md 2026-04-20).
    if (btn.dataset.added === 'true') return;

    // Synchronous visual feedback FIRST — before any DOM lookup or delegation.
    // On the single-variant path, the native animation cascade lands inside the
    // cart drawer, not on our button; setting data-added here guarantees the
    // checkmark-burst fires on the clicked element regardless of where the
    // native path's own animation ends up. (DECISIONS.md 2026-04-22)
    btn.dataset.added = 'true';
    var clearAdded = setTimeout(function () {
      btn.removeAttribute('data-added');
    }, 800);

    var card = btn.closest('product-card');
    var quickAdd = card ? card.querySelector('quick-add-component') : null;
    // Horizon decides add-vs-choose server-side (snippets/quick-add.liquid:25-28)
    // and toggles visibility via this attribute. Pick the active button.
    var mode = quickAdd ? quickAdd.getAttribute('data-quick-add-button') || 'choose' : null;
    var selector = mode === 'add' ? '.quick-add__button--add' : '.quick-add__button--choose';
    var nativeBtn = quickAdd ? quickAdd.querySelector(selector) : null;

    if (!nativeBtn || nativeBtn.disabled) {
      // Error path: roll back the visual feedback immediately so retry clicks
      // aren't blocked by the re-entrancy guard.
      clearTimeout(clearAdded);
      btn.removeAttribute('data-added');
      console.warn('[groovi-card-atc] Native quick-add button not found');
      return;
    }

    // Trigger the native path — works even when the native wrapper is `display:none`,
    // because programmatic .click() bypasses hit-testing but still dispatches the
    // click event that Horizon's `on:click` directives (delegated on the component)
    // listen for.
    nativeBtn.click();
  });
})();
